// Display · EntityLinkContext
//
// Holds a render function for entity links so that `domain/` and `tables/`
// components can render interactive entity links WITHOUT importing from
// `connected/` (which is above them in the tier order).
//
// Default renderer: pure-visual `EntityChip` (no navigation, no popover).
// Connected provider: `@ds/connected/EntityLinkProvider` injects the real
// `EntityLink` component so all interaction works in the running app.
//
// Lower tiers (domain, tables, display) read the renderer through
// `@ds/display/entityLinkRendererContext` (context object + hook).
// `connected/` is the only tier that imports from connected/EntityLink —
// it sets the context at app mount, propagating downward.

import React, { type ReactNode } from "react";
import {
  EntityLinkContext,
  type EntityLinkRenderer,
} from "@ds/display/entityLinkRendererContext";

export type {
  EntityLinkRenderer,
  EntityLinkRendererProps,
} from "@ds/display/entityLinkRendererContext";

// ─── Provider (used by connected/EntityLinkProvider) ────────────────────────

export interface EntityLinkContextProviderProps {
  renderer: EntityLinkRenderer;
  children: ReactNode;
}

export function EntityLinkContextProvider({
  renderer,
  children,
}: EntityLinkContextProviderProps): React.ReactElement {
  return (
    <EntityLinkContext.Provider value={renderer}>
      {children}
    </EntityLinkContext.Provider>
  );
}
